import Cookies from "js-cookie";
import store from "../config/configureStore";
import { getSettings, clearSettings } from "./ConfigReducer";
import { notify } from "./NotifierReducer";
import { getScreensView, setCircularLoading } from "./UiReducer";
import { getUserSettings } from "./UserSettingsReducer";
import {
  checkForNewVersion,
  updateApp,
  updateIfNewVersionAvail,
} from "./AppInfoReducer";
import { AMSModules } from "../utils/constants";
import { getDictionaries } from "./DictionaryReducer";

export const USER_SET_AUTHENTICATED = "USER/SET_AUTHENTICATED";
export const USER_SECOND_FACTOR = 'USER/USER_SECOND_FACTOR';
export const USER_SET_DATA = "USER/SET_DATA";
export const USER_SET_USER_UNIT = "USER/USER_SET_USER_UNIT";
export const USER_SET_USER_UNITS = "USER/SET_USER_UNITS";
export const USER_CLEAR_DATA = "USER/USER_CLEAR_DATA";
export const USER_SET_PERMISSION = "USER/USER_SET_PERMISSION";
export const PASSWORD_FIELD_SHOULD_RESET = "PASSWORD_FIELD_SHOULD_RESET";
export const USER_SET_OTP_REQUIRED = "USER/SET_OTP_REQUIRED";
export const USER_SET_AGENCY = "USER/SET_AGENCY";
let logOutSent = false;

export const submitLoginForm = (username, password, secondFactor) => {
  const client = store.store.getState().websocket.websocket;
  return async (dispatch) => {
    try {
      dispatch(setCircularLoading(true));
      const authPayload = {
        AppName: "AMS",
        strategy: "local",
        username: username,
        password: password,
      };
      if (secondFactor) {
        authPayload.otp = secondFactor;
      };
      const authResponse = await client.authenticate(authPayload);
      logOutSent = false;
      dispatch({
        type: USER_SET_AGENCY,
        payload:
          authResponse.user.AgencyID !== null ? authResponse.user.AgencyID : "",
      });
      dispatch({ type: USER_SET_DATA, payload: authResponse });
      dispatch({ type: USER_SET_AUTHENTICATED, payload: true });
      dispatch({ type: USER_SECOND_FACTOR, payload: false });
      dispatch(getSettings());
      dispatch(getUserSettings(authResponse?.user?.ptsUserID));
      dispatch(updateIfNewVersionAvail());
      if (authResponse?.user?.ptsUserID) dispatch(getScreensView(authResponse?.user?.ptsUserID))
      //dispatch(updateZones());
    } catch (error) {
       if (!error.data) {
         const { code, message } = error;
         switch (code) {
           case 408:
             dispatch(
               notify(
                 "It takes too long to connect to the server. Please check your connection and try again.",
                 "warning"
               )
             );
             break;
           case 401:
              dispatch({ type: PASSWORD_FIELD_SHOULD_RESET, payload: true });
              dispatch({ type: USER_SET_OTP_REQUIRED, payload: false });
              dispatch(notify(message, "error"));
             break;
           default:
             dispatch(
               notify(
                 `Unknown error ${code}. Please check your connection and try again.`,
                 "error"
               )
             );
             dispatch({ type: USER_SET_OTP_REQUIRED, payload: false });
         }
        } else {
          if (error.data.secondFactor) {
            dispatch(notify('Authentication token has been sent (email)', 'warning'));
            dispatch({ type: USER_SET_AUTHENTICATED, payload: false });
            dispatch({ type: USER_SECOND_FACTOR, payload: true });
          } else {
            dispatch(
              notify(
                'It takes too long to connect to the server. Please check your connection and try again.',
                'warning'
              )
            );
          }
       }
    } finally {
      dispatch(setCircularLoading(false));
    }
  };
};

export const sendPassResetLink = (username, isResendRequest = false) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }
  const service = client.service("pass-reset");
  // service.timeout = 40000;

  return service.create({
    action: "pass-reset",
    email: null,
    ResetMethod: "email",
    AppName: "AMS",
    RedirectTo: window.__RUNTIME_CONFIG__.REACT_APP_PUBLIC_URL + "/Reset-password",
    username,
    isResendRequest,
  });
};

export const setUserAuthenticated = (state) => {
  const client = store.store.getState().websocket.websocket;
  return (dispatch) => {
    if (client) {
      if (state === false) {
        dispatch(logOut());
        dispatch({ type: AMSModules.LogOut });
      } else {
        dispatch({ type: USER_SET_AUTHENTICATED, payload: true });
      }
    }
  };
};

export const logOut = () => async (dispatch) => {
  if (logOutSent) return;
  logOutSent = true;
  try {
    const state = store.store.getState();
    const { appInfo } = state;
    const client = state.websocket.websocket;
    client
      .service("authenticate")
      .remove("AMS")
      .catch((e) => {});
    client.logout();

    window.localStorage.removeItem("auth");
    dispatch({ type: USER_CLEAR_DATA });
    dispatch({ type: USER_SET_AUTHENTICATED, payload: false });
    dispatch(clearSettings());

    const { registration } = appInfo;
    if (registration) {
      updateApp(registration);
    } else {
      const { buildNo } = appInfo;
      const newVer = await checkForNewVersion();
      if (buildNo && buildNo !== newVer?.build) window.location.reload();
    }
  } catch (err) {
    console.log(err);
  }

  // dispatch(setUserData(null));
};

export const setUserData = (data) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_DATA, payload: data });
  };
};

export const validateResetPassHash = (hash, username) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }
  const service = client.service("pass-reset");
  // service.timeout = 40000;
  return service.get(hash, { query: { username } });
};

export const resetPass = (code, newPass, username) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }
  const service = client.service("pass-reset");
  // service.timeout = 40000;
  return service.patch(code, { newPass, AppName: "AMS", username: username });
};

export const setPasswordFieldShouldReset = (flag = false) => {
  return (dispatch) => {
    dispatch({ type: PASSWORD_FIELD_SHOULD_RESET, payload: flag });
  };
};

export const setSecondFactor = (state) => {
  return (dispatch) => {
    dispatch({ type: USER_SECOND_FACTOR, payload: state });
  };
};

const defaultState = {
  isAuthenticated: false,
  userData: null,
  permissions: [],
  secondFactor: false,
  userAgency: "",
};

export const authorizeExternalApp = () => {
  const isProduction = window.__RUNTIME_CONFIG__.NODE_ENV !== "development";
  const auth = window.localStorage.getItem("auth");
  const domain = window.location.hostname;
  const parentDomain = domain.substr(domain.indexOf(".") + 1);
  Cookies.set("auth", auth, {
    expires: new Date(new Date().getTime() + 2500),
    path: "/",
    domain: parentDomain,
    secure: isProduction,
  });
};

export const setUserAgency = (agency) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_AGENCY, payload: agency });
    dispatch(getDictionaries("ams"));
  };
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case USER_SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case USER_SET_DATA:
      return {
        ...state,
        userData: action.payload,
      };
    case USER_CLEAR_DATA:
      return defaultState;
    case USER_SET_PERMISSION:
      return {
        ...state,
        userData: {
          ...state.userData,
          user: {
            ...state.userData.user,
            Permissions: JSON.stringify(action.payload),
          },
        },
      };
    case PASSWORD_FIELD_SHOULD_RESET:
      return {
        ...state,
        passwordFieldShouldReset: action.payload,
      };
    case USER_SECOND_FACTOR:
      return {
        ...state,
        secondFactor: action.payload,
      };
    case USER_SET_AGENCY:
      return {
        ...state,
        userAgency: action.payload,
      };
    default:
      break;
  }
  return state;
}
